import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { tap } from 'rxjs/internal/operators/tap';

export interface Alert {
    type: string;
    message: string;
}

@Injectable({
    providedIn: 'root'
})
export class NewsService {
    private news$: BehaviorSubject<Alert[]> = new BehaviorSubject([]);

    sharedNews$: Observable<Alert[]>;

    constructor(private client: HttpClient) {
        this.sharedNews$ = this.news$.pipe(shareReplay());
        this.load();
    }

    load() {
        const url = environment.restBaseURL + '/news';
        this.client.get<Alert[]>(url).pipe(
            tap(news => this.news$.next(news)),
            catchError(_ => EMPTY) // swallow error
        ).subscribe();
    }

}
